var render = function () {
  var _vm$User$, _vm$User$2, _vm$User$3, _vm$User$4, _vm$User, _vm$User$5;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('HeaderBreadcrumbs', {
    attrs: {
      "items": [{
        label: 'Accounts',
        to: '/customers/list'
      }, {
        label: (_vm$User$ = _vm.User[0]) !== null && _vm$User$ !== void 0 && _vm$User$.first_name && (_vm$User$2 = _vm.User[0]) !== null && _vm$User$2 !== void 0 && _vm$User$2.last_name ? _vm.User[0].first_name + ' ' + _vm.User[0].last_name : 'Detail User'
      }],
      "title": (_vm$User$3 = _vm.User[0]) !== null && _vm$User$3 !== void 0 && _vm$User$3.first_name && (_vm$User$4 = _vm.User[0]) !== null && _vm$User$4 !== void 0 && _vm$User$4.last_name ? _vm.User[0].first_name + ' ' + _vm.User[0].last_name : 'Detail User'
    }
  }), ((_vm$User = _vm.User) === null || _vm$User === void 0 ? void 0 : _vm$User.length) > 0 ? _c('div', {
    staticClass: "bg-white p-0 my-3 rounded-lg shadow-sm"
  }, [_c('Profile', {
    attrs: {
      "user": _vm.User[0],
      "userBannedDetailUserId": _vm.userBannedDetailUserId
    }
  })], 1) : _vm._e(), ((_vm$User$5 = _vm.User[0]) === null || _vm$User$5 === void 0 ? void 0 : _vm$User$5.devices.length) > 0 ? _c('div', [_c('TableDevice', {
    attrs: {
      "User": _vm.User,
      "id": _vm.$route.params.id
    }
  })], 1) : _c('div', [_c('div', {
    staticClass: "overflow-x-auto rounded-lg shadow-sm mb-4 bg-white px-4"
  }, [_c('h4', {
    staticClass: "text-xl font-bold pt-3 pb-2"
  }, [_vm._v("Logged Device Details")]), !_vm.isLoading ? _c('div', {
    staticClass: "relative overflow-x-auto my-2 mb-4 rounded-lg border-gray-200 border-b border-t border-r border-l"
  }, [_c('table', {
    staticClass: "min-w-full text-sm rounded-lg text-left"
  }, [_vm._m(0), _c('tbody', {
    staticClass: "bg-white"
  }, [_c('tr', [_c('td', {
    staticClass: "text-center py-8 text-gray-500",
    attrs: {
      "colspan": "5"
    }
  }, [_c('div', {
    staticClass: "flex-col items-center justify-center flex-nowrap flex"
  }, [_c('svg', {
    staticClass: "w-14 h-14 text-gray-500 dark:text-white",
    attrs: {
      "aria-hidden": "true",
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "fill": "none",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "stroke": "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      "d": "M10 3v4a1 1 0 0 1-1 1H5m4 8h6m-6-4h6m4-8v16a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V7.914a1 1 0 0 1 .293-.707l3.914-3.914A1 1 0 0 1 9.914 3H18a1 1 0 0 1 1 1Z"
    }
  })]), _c('h4', {
    staticClass: "text-base text-gray-600 mb-0"
  }, [_vm._v("No Data")]), _c('p', {
    staticClass: "text-sm text-gray-500"
  }, [_vm._v("There are no data to display")])])])])])])]) : _vm._e()])]), _c('div', {
    staticClass: "shadow-md bg-white rounded-lg p-4 h-custom"
  }, [_c('h4', {
    staticClass: "font-bold text-xl leading-7 mb-4 block"
  }, [_vm._v("Accounts Details")]), _c('div', {
    staticClass: "tabs-container border-b border-gray-300"
  }, [_c('ul', {
    staticClass: "flex space-x-6 text-sm font-medium"
  }, _vm._l(_vm.tabs, function (tab, index) {
    return _c('li', {
      key: index,
      staticClass: "relative",
      class: [_vm.selectedTab === tab.name ? 'text-blue-600' : 'text-gray-500', 'cursor-pointer'],
      on: {
        "click": function ($event) {
          return _vm.handleTabs(tab);
        }
      }
    }, [_c('div', {
      staticClass: "absolute top-9 w-full",
      class: [_vm.selectedTab === tab.name ? 'text-blue-600 border-blue-600 border-b' : 'text-gray-500', 'cursor-pointer']
    }), _vm._v(" " + _vm._s(tab.name) + " ")]);
  }), 0)]), _vm.selectedTab === 'Reading Time History' ? _c('div', [_vm.User[0] && _vm.User[0].id ? _c('reading', {
    attrs: {
      "id": _vm.User[0].id,
      "from": _vm.from,
      "to": _vm.to
    }
  }) : _vm._e()], 1) : _vm.selectedTab === 'Transaction' ? _c('div', [_c('OrderTable', {
    attrs: {
      "items": _vm.items,
      "id": this.$route.params.id,
      "isLoading": _vm.isLoadingOrders,
      "perPage": this.perPageTransaction,
      "currentPage": _vm.currentPageTransaction
    },
    on: {
      "sort-data": _vm.sortData
    }
  }), _vm.rowsTransaction / _vm.perPageTransaction > 1 ? _c('div', [_c('div', {
    staticClass: "flex justify-between ml-1 px-0 items-stretch align-middle flex-wrap"
  }, [_c('div', {
    staticClass: "font-semibold"
  }, [_c('span', {
    staticClass: "text-gray-500 font-normal"
  }, [_vm._v("Showing ")]), _vm._v(" " + _vm._s(_vm.currentPageTransaction) + "-" + _vm._s(_vm.perPageTransaction) + " "), _c('span', {
    staticClass: "text-gray-500 font-normal"
  }, [_vm._v("of")]), _vm._v(" " + _vm._s(parseInt(_vm.rowsTransaction)) + " ")]), _c('div', {}, [_c('t-pagination', {
    staticClass: "rounded-lg",
    attrs: {
      "total-items": Number(_vm.rowsTransaction),
      "per-page": _vm.perPageTransaction
    },
    model: {
      value: _vm.currentPageTransaction,
      callback: function ($$v) {
        _vm.currentPageTransaction = $$v;
      },
      expression: "currentPageTransaction"
    }
  })], 1)])]) : _vm._e()], 1) : _vm.selectedTab === 'Buffets' ? _c('div', [_c('Buffets', {
    attrs: {
      "user": this.$route.params.id,
      "buffets": _vm.buffets,
      "isLoading": _vm.isLoadingBuffets,
      "perPage": this.perPageBuffets,
      "currentPage": _vm.currentPagrBuffets
    },
    on: {
      "sort-data": _vm.sortData
    }
  }), _vm.rowBuffets / this.perPageBuffets > 1 ? _c('div', [_c('div', {
    staticClass: "flex justify-between ml-0 px-0 items-stretch align-middle flex-wrap"
  }, [_c('div', {
    staticClass: "font-semibold"
  }, [_c('span', {
    staticClass: "text-gray-500 font-normal"
  }, [_vm._v("Showing ")]), _vm._v(" " + _vm._s(_vm.currentPagrBuffets) + "-" + _vm._s(_vm.perPageBuffets) + " "), _c('span', {
    staticClass: "text-gray-500 font-normal"
  }, [_vm._v("of")]), _vm._v(" " + _vm._s(parseInt(_vm.rowBuffets)) + " ")]), _c('div', {}, [_c('t-pagination', {
    staticClass: "rounded-lg",
    attrs: {
      "total-items": Number(_vm.rowBuffets),
      "per-page": _vm.perPageBuffets
    },
    model: {
      value: _vm.currentPagrBuffets,
      callback: function ($$v) {
        _vm.currentPagrBuffets = $$v;
      },
      expression: "currentPagrBuffets"
    }
  })], 1)])]) : _vm._e()], 1) : _vm.selectedTab === 'Subscription' ? _c('div', [_c('Subscription', {
    attrs: {
      "user": this.$route.params.id,
      "subscription": _vm.subscription,
      "isLoading": _vm.isLoading,
      "perPage": _vm.perPageScubcription,
      "currentPage": _vm.currentPageSubcription
    },
    on: {
      "sort-data": _vm.sortData
    }
  }), _vm.totalRowsSubcription / this.perPageScubcription > 1 ? _c('div', {
    staticClass: "mt-3"
  }, [_c('div', {
    staticClass: "flex justify-between ml-0 px-0 items-stretch align-middle flex-wrap"
  }, [_c('div', {
    staticClass: "font-semibold"
  }, [_c('span', {
    staticClass: "text-gray-500 font-normal"
  }, [_vm._v("Showing ")]), _vm._v(" " + _vm._s(_vm.currentPageSubcription) + "-" + _vm._s(_vm.perPageScubcription) + " "), _c('span', {
    staticClass: "text-gray-500 font-normal"
  }, [_vm._v("of")]), _vm._v(" " + _vm._s(parseInt(_vm.totalRowsSubcription)) + " ")]), _c('div', {}, [_c('t-pagination', {
    staticClass: "rounded-lg",
    attrs: {
      "total-items": Number(_vm.totalRowsSubcription),
      "per-page": _vm.perPageScubcription
    },
    model: {
      value: _vm.currentPageSubcription,
      callback: function ($$v) {
        _vm.currentPageSubcription = $$v;
      },
      expression: "currentPageSubcription"
    }
  })], 1)])]) : _vm._e()], 1) : _vm.selectedTab === 'Single' ? _c('div', [_c('Single', {
    attrs: {
      "user": this.$route.params.id,
      "UserItems": _vm.UserItems,
      "isLoading": _vm.isloadingUserItem,
      "perPage": _vm.perPageSingle,
      "currentPage": _vm.currentPageSingle
    },
    on: {
      "sort-data": _vm.sortData,
      "switch-change": _vm.handleSwitchChange,
      "handle-filter": _vm.handleFiller,
      "reset-filter": _vm.handleReset
    }
  }), _vm.countSingle / _vm.perPageSingle > 1 ? _c('div', {
    staticClass: "mt-3"
  }, [_c('div', {
    staticClass: "flex justify-between ml-1 px-0 items-stretch align-middle flex-wrap"
  }, [_c('div', {
    staticClass: "font-semibold"
  }, [_c('span', {
    staticClass: "text-gray-500 font-normal"
  }, [_vm._v("Showing ")]), _vm._v(" " + _vm._s(_vm.currentPageSingle) + "-" + _vm._s(_vm.perPageSingle) + " "), _c('span', {
    staticClass: "text-gray-500 font-normal"
  }, [_vm._v("of")]), _vm._v(" " + _vm._s(parseInt(_vm.countSingle)) + " ")]), _c('div', {}, [_c('t-pagination', {
    staticClass: "rounded-lg",
    attrs: {
      "total-items": Number(_vm.countSingle),
      "per-page": _vm.perPageSingle
    },
    model: {
      value: _vm.currentPageSingle,
      callback: function ($$v) {
        _vm.currentPageSingle = $$v;
      },
      expression: "currentPageSingle"
    }
  })], 1)])]) : _vm._e()], 1) : _vm._e()])], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('thead', {
    staticClass: "bg-gray-50 text-gray-700"
  }, [_c('tr', {
    staticClass: "text-center"
  }, [_c('th', {
    staticClass: "px-2 py-3 text-center bg-gray-100 border-0 font-semibold upprace uppercase text-xs text-gray-500 border-b"
  }, [_vm._v("No")]), _c('th', {
    staticClass: "px-2 py-3 text-center bg-gray-100 border-0 font-semibold upprace uppercase text-xs text-gray-500 border-b"
  }, [_vm._v("Device ID")]), _c('th', {
    staticClass: "px-2 py-3 text-center bg-gray-100 border-0 font-semibold upprace uppercase text-xs text-gray-500 border-b"
  }, [_vm._v("Device Type")]), _c('th', {
    staticClass: "px-2 py-3 text-center bg-gray-100 border-0 font-semibold upprace uppercase text-xs text-gray-500 border-b"
  }, [_vm._v("IMEI")]), _c('th', {
    staticClass: "px-2 py-3 text-center bg-gray-100 border-0 font-semibold upprace uppercase text-xs text-gray-500 border-b"
  }, [_vm._v("Last Modified Date")])])]);
}]

export { render, staticRenderFns }